import { mutatorAction } from 'satcheljs';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
export var updateSessionSettings = mutatorAction('updateSessionSettings', function (defaultFromAddress) {
    getUserConfiguration().SessionSettings.DefaultFromAddress = defaultFromAddress;
});
//# sourceMappingURL=updateSessionSettings.js.map